import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import faTrashAlt from '@fortawesome/fontawesome-free-solid/faTrashAlt';
import faEdit from '@fortawesome/fontawesome-free-solid/faEdit';

import Contact from '../../../models/Contact';
import Button from '../../common/Button';
import './ContactView.css';
import emailIcon from '../../../images/email.svg';
import phoneIcon from '../../../images/phone.svg';

function renderLocation(location) {
  return location ? `(${location})` : null;
}

function renderFocus(focus) {
  return focus ? `Focuses on ${focus.toLowerCase()}` : <em>(No known focus)</em>;
}

function renderNotes(notes) {
  return notes || null;
}

function renderEmail(email) {
  return email ? <a href={`mailto:${email}`}>{email}</a> : <em>- none</em>;
}

function renderPhone(phone) {
  return phone ? <a href={`tel:${phone.replace(/\D/g, '')}`}>{phone}</a> : <em>- none</em>;
}

class ContactView extends PureComponent {
  onDeleteContact = () => {
    const {
      contact: { name, id },
      onDelete,
    } = this.props;

    // eslint-disable-next-line no-alert, no-restricted-globals
    if (confirm(`Are you sure you want to delete the contact "${name}"?`)) {
      onDelete(id);
    }
  };

  render() {
    const { contact } = this.props;

    return (
      <div className="columns is-centered">
        <div className="column is-half-desktop">
          <div className="contactView box">
            <h2 className="contactView-name title is-4">{contact.name}</h2>
            <div className="contactView-type is-size-7">
              {contact.type} {renderLocation(contact.location)}
            </div>

            <div className="contactView-info">
              <p>{renderFocus(contact.focus)}</p>
              <br />
              <p>{renderNotes(contact.notes)}</p>
            </div>

            <div className="contactView-methods">
              <div className="contactView-email">
                <img src={emailIcon} alt="Email: " className="contactView-icon" />{' '}
                {renderEmail(contact.email)}
              </div>
              <div className="contactView-phone">
                <img src={phoneIcon} alt="Phone: " className="contactView-icon" />{' '}
                {renderPhone(contact.phoneNumber)}
              </div>
            </div>

            <div className="contactView-actions">
              <Button
                label={<FontAwesomeIcon icon={faTrashAlt} />}
                color="danger"
                handler={this.onDeleteContact}
              />
              <Link to={`/contacts/${contact.id}/edit`} className="button is-link">
                <FontAwesomeIcon icon={faEdit} className="icon" size="xs" /> <span>Edit</span>
              </Link>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

ContactView.propTypes = {
  contact: PropTypes.instanceOf(Contact).isRequired,
  onDelete: PropTypes.func.isRequired,
};

export default ContactView;



// WEBPACK FOOTER //
// ./src/components/pages/contacts/ContactView.jsx